<template>
  <div class="relative min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-slate-50 overflow-hidden">

    <div class="bg-shape1"></div>
    <div class="bg-shape2"></div>
    <div class="bg-shape3"></div>

    <div class="relative sm:mx-auto sm:w-full sm:max-w-md z-10 px-4 sm:px-0">

      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-tr from-blue-500 to-indigo-500 shadow-lg shadow-indigo-500/30 mb-4 transform transition hover:scale-105 duration-300">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path></svg>
        </div>
        <h2 class="text-3xl font-extrabold text-slate-800 tracking-tight">
          轻舟魔方授权中心
        </h2>
        <p class="mt-2 text-sm text-slate-500">
          欢迎回来，请登录您的管理账号
        </p>
      </div>

      <div class="bg-white/40 backdrop-blur-2xl border border-white/60 py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 transition-all">
        <form class="space-y-6" @submit.prevent="login">

          <div>
            <label for="username" class="block text-sm font-semibold text-slate-700 ml-1">用户名</label>
            <div class="mt-2">
              <input
                id="username"
                v-model="form.username"
                name="username"
                type="text"
                required
                class="appearance-none block w-full px-4 py-3 border border-slate-200/60 bg-white/70 backdrop-blur-sm rounded-xl text-slate-800 shadow-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 focus:bg-white transition-all duration-300 sm:text-sm"
                placeholder="请输入您的用户名"
              />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-semibold text-slate-700 ml-1">密码</label>
            <div class="mt-2">
              <input
                id="password"
                v-model="form.password"
                name="password"
                type="password"
                required
                class="appearance-none block w-full px-4 py-3 border border-slate-200/60 bg-white/70 backdrop-blur-sm rounded-xl text-slate-800 shadow-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 focus:bg-white transition-all duration-300 sm:text-sm"
                placeholder="请输入您的密码"
              />
            </div>
          </div>

          <div class="pt-2">
            <button
              type="submit"
              :disabled="loading"
              class="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-xl shadow-lg shadow-indigo-500/30 text-sm font-bold text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transform transition-all duration-300 hover:-translate-y-1 hover:shadow-indigo-500/50 disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none"
            >
              <i v-if="loading" class="fas fa-spinner fa-spin mr-2 mt-0.5"></i>
              {{ loading ? '正在登录中...' : '立即登录' }}
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import api from '../services/api';

export default {
  name: 'Login',
  emits: ['login-success'],
  setup(props, { emit }) {
    const router = useRouter();
    const loading = ref(false);

    const form = reactive({
      username: '',
      password: ''
    });

    const login = async () => {
      try {
        loading.value = true;
        const response = await api.login(form);

        // 管理凭证由服务端写入 HttpOnly 加密 Cookie，JavaScript 只保存非敏感展示信息。
        const { user } = response.data;
        localStorage.removeItem('token');
        localStorage.setItem('user', JSON.stringify(user));

        // 触发login-success事件通知父组件
        emit('login-success', user);

        router.push('/dashboard');
        ElMessage.success('登录成功');
      } catch (error) {
        const status = error?.response?.status;
        const message = error?.response?.data?.error ||
          (status ? '登录失败，请稍后再试' : '无法连接登录服务，请检查网络');
        // Axios 错误对象可能包含原始请求体，不能把管理员密码打印到控制台。
        if (import.meta.env.DEV) console.warn('Login request failed', { status });
        ElMessage.error(message);
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      loading,
      login
    };
  }
};
</script>

<style scoped>
/* 自定义动态悬浮光晕动画 */
.bg-shape1 {
  position: absolute;
  width: 500px;
  height: 500px;
  background: rgba(165, 180, 252, 0.4); /* 柔和的靛蓝色 */
  border-radius: 50%;
  filter: blur(80px);
  top: -150px;
  left: -100px;
  animation: float 12s infinite ease-in-out;
}

.bg-shape2 {
  position: absolute;
  width: 400px;
  height: 400px;
  background: rgba(196, 181, 253, 0.4); /* 柔和的紫色 */
  border-radius: 50%;
  filter: blur(80px);
  bottom: -100px;
  right: -50px;
  animation: float 15s infinite ease-in-out reverse;
}

.bg-shape3 {
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(147, 197, 253, 0.3); /* 柔和的浅蓝色 */
  border-radius: 50%;
  filter: blur(60px);
  top: 30%;
  left: 60%;
  animation: float 10s infinite ease-in-out 2s;
}

@keyframes float {
  0% {
    transform: translateY(0px) scale(1);
  }
  50% {
    transform: translateY(30px) scale(1.05);
  }
  100% {
    transform: translateY(0px) scale(1);
  }
}
</style>
